import React, { useEffect, useMemo } from 'react'
import { Box, Typography, CircularProgress } from '@mui/material'
import { useOutletContext } from 'react-router-dom'

import WizardContainer from './shared/WizardContainer'
import WizardFooter from './shared/WizardFooter'
import useContactTypes from '../hooks/api/useContactTypes'
import { ContactTypesForm } from '../settings/ContactTypes'
import useAlert from '../hooks/useAlert'

const ContactTypes = () => {
  const {
    navigateToNext,
    companyConfig,
    updateCompanyConfig,
    wizardState,
    updateWizardState,
  } = useOutletContext()

  const { contactTypes = [] } = wizardState

  const hasInitializedData = useMemo(() => !!wizardState.contactTypes, [])

  const {
    contactTypes: contactTypesData,
    setContactTypes: setContactTypesData,
    saveContactTypes,
    isLoading,
  } = useContactTypes()

  useEffect(() => {
    if (hasInitializedData) return setContactTypesData(contactTypes)

    updateWizardState({ contactTypes: contactTypesData })
  }, [contactTypesData])

  const setContactTypes = (contactTypes) => {
    updateWizardState({ contactTypes })
    setContactTypesData(contactTypes)
  }

  const { createAlert } = useAlert()

  const onSubmit = () => {
    const newConfig = {
      ...companyConfig,
      hasSavedContacts: true,
    }

    updateCompanyConfig(newConfig)
      .then(saveContactTypes)
      .then(() => {
        navigateToNext()
      })
      .catch((e) => {
        createAlert({
          severity: 'error',
          message: 'Something went wrong',
          action: {
            label: 'Skip this step',
            onClick: () => navigateToNext(),
          },
        })
      })
  }

  return (
    <WizardContainer>
      <Typography variant={'h5'}>Contacts</Typography>

      {isLoading && <CircularProgress />}
      <Box sx={{ mb: 2 }}>
        <Typography>
          This is where you’ll define the titles and influences of your business
          contacts. We’ve added some default options for you, but these are only
          suggestions. You are the master, we are the violin!
        </Typography>
      </Box>

      <ContactTypesForm
        contactTypes={contactTypes}
        setContactTypes={setContactTypes}
      />

      <WizardFooter
        primaryButton={{ label: 'Save and continue', onClick: onSubmit }}
      />
    </WizardContainer>
  )
}

export default ContactTypes
